<template>
  <div>
    <SubscriptionOrderList :account-subscription="accountSubscription" />
  </div>
</template>

<script>
import SubscriptionOrderList from './subscriptionOrders/components/SubscriptionOrderList.vue';

export default {
  name: 'AccountSubscriptionSubscriptionOrdersPage',
  components: {
    SubscriptionOrderList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    accountSubscriptionUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      accountSubscriptionOrders: [],
    };
  },
  computed: {
    accountSubscription() {
      return (
        this.$store.state.entities.accountSubscriptions.byId[this.accountSubscriptionUuid] || null
      );
    },
  },
};
</script>
